import { FieldType, FormField, PROMPTS, WidthClass } from '@thehubz/client/core';

export const allianzFields: FormField[] = [
  {
    formTypeId: '2',
    formFieldName: 'assetSource',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Source of asset`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: ['Allianz Produktion', 'Adobe', 'Getty images', 'Fotolia', 'Shutterstock', 'Allianz Creators', 'Sonstige'],
  },
  {
    formTypeId: '2',
    formFieldName: 'team',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Team`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: ['Werbung', 'Sponsoring', 'Zielgruppenkommunikation'],
  },
  {
    formTypeId: '1',
    formFieldName: 'responsibleAgency',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Responsible agency`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '2',
    formFieldName: 'targetGroup',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Target group`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: ['B2B', 'B2C'],
  },
  {
    formTypeId: '2',
    formFieldName: 'licenseType',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Type of license`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'usageRight',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: [
      'Angaben vom Hersteller fehlen',
      'bei Herausgeber zu erfragen',
      'Lizenzfrei',
      'lizenzfrei (erweitert)',
      'lizenzfrei (Standard)',
      'lizenzpflichtig',
    ],
  },
  {
    formTypeId: '2',
    formFieldName: 'rightsToUseOriginalFile',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Rights to use the original file`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'usageRight',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: ['Allianz SE (global)', 'Allianz Deutschland (deutschlandweit)', 'ABV', 'Allianz Sach', 'Allianz Leben ', 'Allianz Kranken'],
  },
  {
    formTypeId: '2',
    formFieldName: 'permittedTypesToUse',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Permitted types of use`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'usageRight',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: [
      'ohne Einschränkungen',
      'Nur analog',
      'Nur digital',
      'Nur TV',
      'Nur Social',
      'Analog & Digital',
      'Analog & TV',
      'Analog & Social',
      'TV & Digital',
      'TV & Social',
      'Digital & Social',
      'Analog, digital, TV',
      'Analog, digital, Social',
      'Digital, TV, Social',
    ],
  },
  {
    formTypeId: '2',
    formFieldName: 'assetVariant',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Variant`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'usageRight',
    formGroup: false,
    disable: false,
    editable: true,
    visible: true,
    options: ['Zentral', 'Vertreter'],
  },
  {
    formTypeId: '1',
    formFieldName: 'spotType',
    fieldType: FieldType.Text,
    fieldLabel: $localize`:video metadata:Spot type`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    assetType: ['Video'],
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'audioFile',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Audio file`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: 'text',
    mandatory: false,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    assetType: ['Video'],
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    formGroup: false,
    editable: true,
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'internalRemark',
    fieldType: FieldType.Textarea,
    fieldLabel: $localize`Internal remark`,
    placeholder: $localize`Internal remark`,
    inputType: 'text',
    mandatory: false,
    minlength: 5,
    validationRegex: '',
    widthClass: WidthClass.WFull,
    fieldGroup: 'tagging',
    disable: false,
    functionCall: false,
    visible: true,
  },
];
